module.exports = __webpack_public_path__ + "static/img/report_subject.8740e1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/report_subject.png
// module id = 28us
// module chunks = 4